const getAvatarTemplate = (data) => {
  return `
    <picture class="ui-text-review-header__avatar-wrapper">
      ${data.avatar.webp
          ? `<source
              type="image/webp"
              srcset="${data.avatar.webp}"
            >`
          : ''
        }

      <img
        src="${data.avatar.img}"
        class="ui-text-review-header__avatar"
        loading="lazy"
        decoding="async"
        width="44"
        height="44"
        alt=""
      >
    </picture>
  `
}

const getInitialsTemplate = (data) => {
  return `
    <div class="ui-text-review-header__avatar-wrapper ui-text-review-header__avatar-wrapper--initials f f--18 f--m"></div>
  `
}

const getAuthorTemplate = (data) => {
  let author = data.name

  if (data.city) {
    author = `${data.name}, ${data.city}`
  }

  return `
    <span class="ui-text-review-header__author f f--16 f--m">
      ${author}
    </span>
  `
}

const getCourseTemplate = (data) => {
  return `
    <span class="ui-text-review-header__course f f--14 f--m">
      ${data.course.type}
      
      <a href="${data.course.url}" target="_blank">
        ${data.course.title}
      </a>
    </span>
  `
}

const getStarTemplate = (isGrey) => {
  return (
    `<svg
      class="ui-text-review-header__star ${isGrey ? 'ui-text-review-header__star--grey' : ''}"
      width="12"
      height="12"
      aria-hidden="true"
    >
      <use href="#ui-star-dark" />
    </svg>`
  )
}

const getRatingTemplate = (data) => {
  return `
    <div class="ui-text-review-header__rating" role="img" aria-label="Оценка курса: ${data.rating}">
      ${Array.from(''.padStart(data.rating, '*').padEnd(5, '-')).map((item) => {
        return item === '*' ? getStarTemplate() : getStarTemplate(true)
      }).join('')}
    </div>
  `
}

const getUiTextReviewHeaderTemplate = ({ data, classes }) => {
  return `
    <div class="ui-text-review-header ${classes}">
      ${data.avatar ? getAvatarTemplate(data) : getInitialsTemplate(data)}
      
      ${getAuthorTemplate(data)}
      
      ${getCourseTemplate(data)} 
      
      ${data.rating ? getRatingTemplate(data) : ''}
    </div>
  `
}

export const UiTextReviewHeaderVanilla = (
  {
    data = {},
    classes = ''
  }
) => {
  const options = { data, classes }

  return getUiTextReviewHeaderTemplate(options)
}
